/* eslint-disable no-bitwise */
/* eslint-disable no-undef */

'use strict';

const errMsgSelector = '.error-message';
const errMsgTxtSelector = '.error-message-text';

/**
 * Remove existing peach form widget and script if checkout session has changed
 */
function removeExistingForm() {
    var existingPeachForm = $('.wpwl-container');
    var existingPeachScript = $('#peachWidget');

    if (window.wpwl && window.wpwl.unload) {
        // remove event bindings and stop iframe communication
        window.wpwl.unload();
    }

    if (existingPeachForm.length) {
        existingPeachForm.remove();
    }

    if (existingPeachScript.length) {
        existingPeachScript.remove();
    }
}

/**
 * Appends a custom error message below a field on the credit card payment form
 * @param {string} containerSelector css selector for the parent element to append the custom error to
 * @param {string} errorText the custom error message to display
 */
function appendCustomError(containerSelector, errorText) {
    $(`${containerSelector} .wpwl-hint-customError`).remove();
    $(containerSelector).append(`<div class='wpwl-hint wpwl-hint-customError'>${errorText}</div>`);
}

/**
 * Validate card number on the CAP payment form is valid
 * @param {boolean} updateCustomErr flag indicating if the custom error should be updated
 * @returns {boolean} true if card number is valid, false otherwise
 */
function validateCardNumber(updateCustomErr) {
    var cardNumberIsValid = $('#peach-payment-form input[name=\'isCardNumberValid\']').val() === 'true';
    var cardNumberIsEmpty = $('#peach-payment-form input[name=\'isCardNumberEmpty\']').val() === 'true';

    if (updateCustomErr) {
        if (cardNumberIsEmpty) {
            appendCustomError('.wpwl-wrapper-cardNumber', 'Invalid card number or brand');
        } else {
            $('.wpwl-wrapper-cardNumber .wpwl-hint-customError').remove();
        }
    }

    return cardNumberIsValid;
}

/**
 * Validate expiry on the CAP payment form is valid
 * @param {boolean} updateCustomErr flag indicating if the custom error should be updated
 * @returns {boolean} true if expiry is valid, false otherwise
 */
function validateExpiry(updateCustomErr) {
    var expiry = $('.wpwl-control-expiry').val();
    var expiryIsValid = expiry.replaceAll(' ', '').length === 5;
    var expiryIsEmpty = expiry.replaceAll(' ', '').length === 0;

    if (updateCustomErr) {
        if (expiryIsEmpty) {
            appendCustomError('.wpwl-wrapper-expiry', 'Invalid expiry date');
        } else {
            $('.wpwl-wrapper-expiry .wpwl-hint-customError').remove();
        }
    }

    return expiryIsValid;
}

/**
 * Validate card holder on the CAP payment form is valid
 * @param {boolean} updateCustomErr flag indicating if the custom error should be updated
 * @returns {boolean} true if card holder is valid, false otherwise
 */
function validateCardHolder(updateCustomErr) {
    var cardHolderElement = $('.wpwl-control-cardHolder');
    var cardHolderIsValid = false;
    if (cardHolderElement) {
        var cardHolder = cardHolderElement.val();
        cardHolderIsValid = cardHolder.replaceAll(' ', '').length > 1;
        var cardHolderIsEmpty = cardHolder.replaceAll(' ', '').length === 0;
        if (updateCustomErr) {
            if (cardHolderIsEmpty) {
                appendCustomError('.wpwl-wrapper-cardHolder', 'Invalid card holder');
            } else {
                $('.wpwl-wrapper-cardHolder .wpwl-hint-customError').remove();
            }
        }
    }
    return cardHolderIsValid;
}

/**
 * Validate security code on the CAP payment form is valid
 * @param {boolean} updateCustomErr flag indicating if the custom error should be updated
 * @returns {boolean} true if security code is valid, false otherwise
 */
function validateSecurityCode(updateCustomErr) {
    var securityCodeIsValid = $('#peach-payment-form input[name=\'isSecurityCodeValid\']').val() === 'true';
    var securityCodeIsEmpty = $('#peach-payment-form input[name=\'isSecurityCodeEmpty\']').val() === 'true';

    if (updateCustomErr) {
        if (securityCodeIsEmpty) {
            appendCustomError('.wpwl-wrapper-cvv', 'Invalid CVV');
        } else {
            $('.wpwl-wrapper-cvv .wpwl-hint-customError').remove();
        }
    }

    return securityCodeIsValid;
}

/**
 * Update peach form widget with information from billing address
 * @param {Function} forms Peach forms
 */
function preparePeachForm(forms) {
    var country = $('#billingCountry').val();
    var city = $('#billingcity').val();
    var street = $('#billingaddress1').val();
    var postalCode = $('#billingpostalCode').val();
    var email = $('#billingemail').val();

    if ($('.supplimentBillingFields').length) {
        $('form.wpwl-form-card input[name="billing.city"]').val(city);
        $('form.wpwl-form-card input[name="billing.country"]').val(country);
        $('form.wpwl-form-card input[name="billing.street1"]').val(street);
        $('form.wpwl-form-card input[name="billing.postcode"]').val(postalCode);
        $('form.wpwl-form-card input[name="customer.email"]').val(email);
    } else {
        var paymentDetails = '<div class="supplimentBillingFields">'
            + '<input type="hidden" name="billing.city" value="' + city + '"/>'
            + '<input type="hidden" name="billing.country" value="' + country + '"/>'
            + '<input type="hidden" name="billing.street1" value="' + street + '"/>'
            + '<input type="hidden" name="billing.postcode" value="' + postalCode + '"/>'
            + '<input type="hidden" name="customer.email" value="' + email + '"/>'
            + '</div>';
        $('form.wpwl-form-card').append(paymentDetails);
        var peachForm = forms.length ? forms[0] : null;
        window.wpwl.form = peachForm;

        $('#peach-payment-form').append(`
            <input type="hidden" name="isSecurityCodeValid" value="false"/>
            <input type="hidden" name="isSecurityCodeEmpty" value="true"/>
            <input type="hidden" name="isCardNumberValid" value="false"/>
            <input type="hidden" name="isCardNumberEmpty" value="true"/>
        `);
        $('.wpwl-control-expiry').on('blur', function () {
            var expiryDate = $(this).val();
            var isEmpty = expiryDate.replaceAll(' ', '').length === 0;
            var isValid = expiryDate.replaceAll(' ', '').length === 5;
            if (isEmpty || isValid) {
                $(this).removeClass('wpwl-has-error');
                $('.wpwl-hint-expiryDateError').remove();
            } else {
                $(this).addClass('wpwl-has-error');
                $('.wpwl-wrapper-expiry').append('<div class="wpwl-hint wpwl-hint-expiryDateError">Invalid expiry date</div>');
            }
            validateExpiry(true);
        });
        $('.wpwl-control-cardHolder').on('blur', function () {
            validateCardHolder(true);
        });
    }
}

/**
 * Configures the Peach widget; must be set before widget is loaded
 */
function setPeachWidgetOptions() {
    if (!window.wpwlOptions) {
        var wpwlOptions = {
            style: 'plain',
            validation: true,
            disableSubmitOnEnter: true,
            disableCardExpiryDateValidation: true,
            allowEmptyCvv: false,
            onReady: preparePeachForm,
            onError: function (error) {
                window.console.error('Peach Payement Error: ' + error);
            },
            onBeforeSubmitCard: function (e) {
                // only submit peach form if on 'place order' stage
                var isPlaceOrderStage = $('.data-checkout-stage').attr('data-checkout-stage') === 'placeOrder';
                if (isPlaceOrderStage) {
                    return true;
                }
                e.preventDefault();
                return false;
            },
            onBlurSecurityCode: function (isValid) {
                $('#peach-payment-form input[name=\'isSecurityCodeValid\']').val(isValid);
                $('#peach-payment-form input[name=\'isSecurityCodeEmpty\']').val(this.isEmpty);
                validateSecurityCode(true);
            },
            onBlurCardNumber: function (isValid) {
                $('#peach-payment-form input[name=\'isCardNumberValid\']').val(isValid);
                $('#peach-payment-form input[name=\'isCardNumberEmpty\']').val(this.isEmpty);
                validateCardNumber(true);
            },
            iframeStyles: {
                'card-number-placeholder': {
                    'font-weight': '300'
                },
                'cvv-placeholder': {
                    'font-weight': '300'
                }
            }
        };

        window.wpwlOptions = wpwlOptions;
    }
}

/**
 * Handle the data sent back from the Peach Payment form
 * @param {Object} data Peach forms
 * @param {Object} $formContainer Container element for peach form
 */
function handlePeachData(data, $formContainer) {
    var peachForm = $.parseHTML(data);
    var checkoutID = $(peachForm).data('checkout-id');
    var checkoutURL = $(peachForm).data('checkout-url');
    var renewCheckoutSession = !window.wpwl || window.wpwl.checkout.id !== checkoutID;

    // add peach form if checkout session doesn't yet exist or has changed
    if (checkoutID && renewCheckoutSession) {
        removeExistingForm();

        $formContainer.append(data);

        var script = document.createElement('script');
        script.id = 'peachWidget';
        script.type = 'text/javascript';
        script.async = true;
        script.src = checkoutURL + checkoutID;
        document.head.appendChild(script);
        $('.billing-address').on('change', 'input, select', preparePeachForm);
    }
}

/**
 * Place the order after the Peach Payments checkout is completed successfully
 * @param {Object} event Peach event data
 */
function handleSuccess(event) {
    var successUrl = $('#peach-embedded-form').data('successurl');
    event.fromOnCompleted = true;
    $.ajax({
        url: successUrl,
        type: 'post',
        data: event,
        success: function (data) {
            if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            }
        },
        error: function (err) {
            if (err.responseJSON.message) {
                $(errMsgSelector).show();
                $(errMsgTxtSelector).text(err.responseJSON.message);
            }
        }
    });
}

/**
 * Invalidate the checkout session, and redirect to the payment stage. This is necessary if a checkout session is cancelled or expires. Otherwise,
 * the payment form won't render when it tries reuse the same checkout ID generated previously.
 * We store this value in currentBasket.custom.peachCheckoutID.
 */
function invalidateCheckoutSession() {
    var invalidateUrl = $('#peach-embedded-form').data('invalidateurl');
    $.ajax({
        url: invalidateUrl,
        success: function (data) {
            if (data.redirectUrl) {
                window.location.href = data.redirectUrl;
            } else {
                console.error('Failed to invalidateCheckoutSession for Peach embedded checkout.');
            }
        },
        error: function (err) {
            if (err.responseJSON.message) {
                $(errMsgSelector).show();
                $(errMsgTxtSelector).text(err.responseJSON.message);
            } else {
                console.error('Failed to invalidateCheckoutSession for Peach embedded checkout.');
            }
        }
    });
}

/**
 * Handle the data sent back from the Peach Embedded Payment form
 * @param {Object} data Peach forms
 * @param {Object} $formContainer Container element for peach form
 */
function handlePeachEmbeddedData(data, $formContainer) {
    const containerName = '#peach-embedded-payment-form';
    $(containerName).remove();
    $formContainer.append(data);
    const $paymentForm = $(containerName);
    const peachEmbeddedCheckout = Checkout.initiate({
        key: $paymentForm.data('entityid'),
        checkoutId: $paymentForm.data('checkoutid'),
        eventHandlers: {
            onCompleted: (event) => handleSuccess(event),
            onCancelled: () => invalidateCheckoutSession(),
            onExpired: () => invalidateCheckoutSession()
        },
        customisations: {
            theme: {
                brand: {
                    primary: '#EC5228',
                    secondary: '#111927'
                },
                cards: {
                    background: '#ffffff',
                    backgroundHover: '#F3F3F4'
                }
            },
            ordering: {
                CARD: 1,
                EFTSECURE: 4,
                MASTERPASS: 2,
                CAPITECPAY: 3
            },
            showCancelButton: true,
            showAmountField: true,
            showCardBrandDisplay: true
        }
    });
    peachEmbeddedCheckout.render(containerName);
}

/**
 * Retrieve the Peach Payments CAP widget for the current checkout session
 */
function initPeachCheckout() {
    var $peachContainer;
    var regex = /[?&]stage=placeOrder([^&]*)/;
    var isPlaceOrderStage = regex.test(window.location.search);
    var $paymentInput = $('[name="dwfrm_billing_paymentMethod"]');
    var $selectedPaymentInput = $('[name="selectedPaymentMethod"]');

    // If review pay is refreshed, check the selectedPaymentMethod input
    // otherwise check the dwfrm_billing_paymentMethod input
    var isPeachCapSelected = $selectedPaymentInput.length
        ? $selectedPaymentInput.val() === 'PEACH_CAP'
        : $paymentInput.val() === 'PEACH_CAP';

    var isPeachEMBSelected = $selectedPaymentInput.length
        ? $selectedPaymentInput.val() === 'PEACH'
        : $paymentInput.val() === 'PEACH_EMB';

    if (isPeachCapSelected) {
        $peachContainer = $('#peach-payment-form');
    } else if (isPeachEMBSelected) {
        $peachContainer = $('#peach-embedded-form');
    }

    if (isPlaceOrderStage && (isPeachEMBSelected || isPeachCapSelected)) {
        if (isPeachCapSelected) {
            setPeachWidgetOptions();
        }
        $.ajax({
            url: $peachContainer.data('url'),
            success: function (data) {
                if (data && !data.error) {
                    if (isPeachCapSelected) {
                        handlePeachData(data, $peachContainer);
                    } else if (isPeachEMBSelected) {
                        handlePeachEmbeddedData(data, $peachContainer);
                    }
                } else if (data && data.error && data.errorMessage) {
                    $(errMsgSelector).show();
                    $(errMsgTxtSelector).text(data.errorMessage);
                }
            },
            error: function (err) {
                if (err.responseJSON.message) {
                    $(errMsgSelector).show();
                    $(errMsgTxtSelector).text(err.responseJSON.message);
                }
            }
        });
    }
}

$(document).on('update:checkout-step', function () {
    initPeachCheckout();
});

module.exports = {
    initPeachCheckout: initPeachCheckout,
    validateCardHolder: validateCardHolder,
    validateCardNumber: validateCardNumber,
    validateExpiry: validateExpiry,
    validateSecurityCode: validateSecurityCode
};
